import { defineStore } from 'pinia';
import { setTelemetryUser } from '@/instrumentation';

export const useAuthStore = defineStore('auth', {
    state: () => ({
        token: '',
        user: null,
        isAuthenticated: false,
    }),
    getters: {
        getToken(state) {
            return state.token;
        },
        getUser(state) {
            return state.user;
        },
        getIsAuthenticated(state) {
            return state.isAuthenticated;
        },
    },
    actions: {
        setToken(token: string) {
            this.token = token;
        },
        setUser(user: any | null) {
            try {
                if (user) {
                    setTelemetryUser({
                        id: user.id,
                        email: user.email,
                        username: user.NIF,
                    });
                } else {
                    setTelemetryUser(null);
                }
            } catch {
                // Avoid breaking auth flows if telemetry is misconfigured.
            }

            this.user = user;
        },
        setIsAuthenticated(isAuthenticated: boolean) {
            this.isAuthenticated = isAuthenticated;
        },
        logout() {
            try {
                setTelemetryUser(null);
            } catch {
                // Avoid breaking logout if telemetry is misconfigured.
            }
            this.setToken('');
            this.setUser(null);
            this.setIsAuthenticated(false);
        },
    },
    persist: true,
});
